import script from "./how-to-join-artemis-ads-as-a-brand.vue?vue&type=script&setup=true&lang=js"
export * from "./how-to-join-artemis-ads-as-a-brand.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__